// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-amo[data-v-978a7532],.card-contact[data-v-978a7532],.card-customer[data-v-978a7532]{min-width:400px;display:flex;flex-direction:column;margin-bottom:2rem}.row-bg[data-v-978a7532]{flex-wrap:wrap}", ""]);
// Exports
module.exports = exports;
